import { render, staticRenderFns } from "./ArtistOverlay.vue?vue&type=template&id=7a1ba4fe&scoped=true"
import script from "./ArtistOverlay.vue?vue&type=script&lang=ts"
export * from "./ArtistOverlay.vue?vue&type=script&lang=ts"
import style0 from "./ArtistOverlay.vue?vue&type=style&index=0&id=7a1ba4fe&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a1ba4fe",
  null
  
)

export default component.exports